import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useRouteMatch } from 'react-router';
import useSWR from 'swr';
import { OutpostDestination } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import NotFound from '../../DashboardScene/NotFound';
import { DestinationOverview } from '../Destinations/DestinationOverview';
import OperatorEventDestinationSettings from './OperatorEventDestinationSettings';
import OperatorEventDeliveriesView from './OperatorEventDeliveriesView';
const OperatorEventDestinationView: React.FC = () => {
  const $ = _c(56);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const route_match = useRouteMatch("/settings/project/monitoring/:destination_id");
  const destination_id = route_match?.params.destination_id;
  let t0;
  if ($[0] !== destination_id) {
    t0 = destination_id ? APIMethodKeys.outpost.operatorEvents.destinations.get(destination_id) : null;
    $[0] = destination_id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== HookdeckAPI.outpost.operatorEvents.destinations || $[3] !== destination_id) {
    t1 = () => {
      if (!destination_id) {
        throw new Error("Operator event destination ID is required.");
      }
      return HookdeckAPI.outpost.operatorEvents.destinations.get(destination_id);
    };
    $[2] = HookdeckAPI.outpost.operatorEvents.destinations;
    $[3] = destination_id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: destination,
    mutate,
    error
  } = useSWR(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = APIMethodKeys.outpost.operatorEvents.destinationTypes.list();
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== HookdeckAPI.outpost.operatorEvents.destinationTypes) {
    t3 = () => HookdeckAPI.outpost.operatorEvents.destinationTypes.list();
    $[6] = HookdeckAPI.outpost.operatorEvents.destinationTypes;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: destination_types
  } = useSWR(t2, t3);
  let t4;
  if ($[8] !== destination || $[9] !== destination_types) {
    t4 = destination ? destination_types?.find(dt => dt.type === destination.type) : undefined;
    $[8] = destination;
    $[9] = destination_types;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const destination_type = t4;
  let t5;
  if ($[11] !== mutate) {
    t5 = updated => {
      mutate(updated);
    };
    $[11] = mutate;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const mutate_destination = t5;
  if (!destination_id) {
    return null;
  }
  const resolved_destination_id = destination_id;
  const path_suffix = location.pathname.split(resolved_destination_id)[1] || "";
  const current_tab = path_suffix.startsWith("/settings") ? "settings" : path_suffix.startsWith("/deliveries") ? "deliveries" : "overview";
  const t6 = `/settings/project/monitoring/${resolved_destination_id}`;
  let t7;
  if ($[13] !== t6) {
    t7 = {
      label: "Overview",
      key: "overview",
      to: t6
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `/settings/project/monitoring/${resolved_destination_id}/settings`;
  let t9;
  if ($[15] !== t8) {
    t9 = {
      label: "Settings",
      key: "settings",
      to: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `/settings/project/monitoring/${resolved_destination_id}/deliveries`;
  let t11;
  if ($[17] !== t10) {
    t11 = {
      label: "Event Deliveries",
      key: "deliveries",
      to: t10
    };
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t7 || $[21] !== t9) {
    t12 = {
      OVERVIEW: t7,
      SETTINGS: t9,
      DELIVERIES: t11
    };
    $[19] = t11;
    $[20] = t7;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const TABS = t12 as const;
  if (error && error?.status === 404) {
    let t13;
    if ($[23] !== resolved_destination_id) {
      t13 = <NotFound title="Operator event destination not found" description="This operator event destination does not exist or has been deleted." id={resolved_destination_id} />;
      $[23] = resolved_destination_id;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    return t13;
  }
  if (!destination) {
    let t13;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Div m={{
        t: 8
      }}><Loading /></Div>;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    return t13;
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      label: "Operator Event Destinations",
      to: "/settings/project/monitoring"
    };
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== resolved_destination_id) {
    t14 = [t13, {
      label: resolved_destination_id,
      highlight: true
    }];
    $[27] = resolved_destination_id;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const breadcrumbs = t14;
  let t15;
  if ($[29] !== breadcrumbs) {
    t15 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} /></StyledViewNavHeader>;
    $[29] = breadcrumbs;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== TABS) {
    t16 = Object.values(TABS);
    $[31] = TABS;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== current_tab || $[34] !== t16) {
    t17 = <StyledViewNavSecondary><Tabs active_tab={current_tab} border={false} tabs={t16} /></StyledViewNavSecondary>;
    $[33] = current_tab;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t17) {
    t18 = <StyledViewNav>{t15}{t17}</StyledViewNav>;
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== current_tab || $[40] !== destination || $[41] !== destination_type) {
    t19 = current_tab === "overview" && <DestinationOverview destination={destination} destination_type={destination_type} attempts_context="operator-events" />;
    $[39] = current_tab;
    $[40] = destination;
    $[41] = destination_type;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== current_tab || $[44] !== destination || $[45] !== destination_type || $[46] !== mutate_destination) {
    t20 = current_tab === "settings" && <OperatorEventDestinationSettings destination={destination} destination_type={destination_type} mutate={mutate_destination} />;
    $[43] = current_tab;
    $[44] = destination;
    $[45] = destination_type;
    $[46] = mutate_destination;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== current_tab || $[49] !== resolved_destination_id) {
    t21 = current_tab === "deliveries" && <OperatorEventDeliveriesView destination_id={resolved_destination_id} />;
    $[48] = current_tab;
    $[49] = resolved_destination_id;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t18 || $[52] !== t19 || $[53] !== t20 || $[54] !== t21) {
    t22 = <>{t18}{t19}{t20}{t21}</>;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  return t22;
};
export default OperatorEventDestinationView;